import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticleGrid() {
  const exclusiveArticle = articles.find(a => a.isExclusive && a.id !== '1') || articles[5];
  const regularArticles = articles.filter(a => a.id !== exclusiveArticle.id).slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
              最新爆料速递
            </h2>
            <p className="text-foreground-500 text-sm md:text-base font-label">
              实时更新，全网热点一手掌握
            </p>
          </div>
          <Link
            to="/category/zuixin-baoliao"
            className="text-primary-500 text-sm font-label flex items-center gap-1 hover:gap-2 transition-all whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="md:col-span-1">
            <Link
              to={`/article/${exclusiveArticle.slug}`}
              className="group block bg-foreground-950 rounded-2xl overflow-hidden card-hover h-full"
            >
              <div className="p-6 pb-4">
                <span className="tag-pill bg-primary-500 text-white font-label mb-3 inline-block">51独家</span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-3 line-clamp-3 leading-snug">
                  {exclusiveArticle.title}
                </h3>
                <p className="text-foreground-300 text-xs line-clamp-2 mb-4 font-label">
                  {exclusiveArticle.excerpt}
                </p>
              </div>
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={exclusiveArticle.imageUrl}
                  alt={exclusiveArticle.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex items-center justify-between">
                <span className="text-foreground-400 text-xs font-label">{exclusiveArticle.publishedAt}</span>
                <span className="text-primary-400 text-xs font-label flex items-center gap-1">
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          </div>

          {regularArticles.map((article) => (
            <div key={article.id} className="md:col-span-1">
              <Link
                to={`/article/${article.slug}`}
                className="group block bg-background-50 rounded-2xl overflow-hidden card-hover border border-background-200/70 h-full"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="tag-pill bg-background-100 text-foreground-600 font-label">
                      {article.category}
                    </span>
                    <span className="text-foreground-400 text-xs font-label">{article.publishedAt}</span>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base line-clamp-2 mb-3 leading-snug group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs line-clamp-2 mb-3 font-label">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-foreground-400 text-xs font-label">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line"></i>
                      {(article.heat / 10000).toFixed(1)}w 热度
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {article.comments} 评论
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}